import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';

export const LogoutButton = ({className}) => {
    const { logout } = useAuth0();

    const handleLogout = () => {
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };

    return (
        <button onClick={handleLogout} className={className}>
            Log Out
        </button>
    );
};
